module.exports = __webpack_public_path__ + "img/clip-o.44c9d4c2.svg";